import Utils from './Utils';

export default {
    getErrorMessages(errors, returnArray, dataVal, overrideMessages) {
        console.log("ERRORS", errors);
        if(!errors) {
            errors = [];
        }

        if(!overrideMessages) {
            overrideMessages = {}
        }

        overrideMessages["20404"] = "Phone number "+dataVal+" is invalid";

        let errorList = [];
        let errorMessages = [];
        for(var idx in errors) {
            let errorObj = errors[idx];

            if(overrideMessages[errorObj.id]) {
                errorObj.message = overrideMessages[errorObj.id];
            }
            errorList.push(errorObj);
            errorMessages.push(Utils.get(errorObj, "message", ""));
        }
        if(returnArray && returnArray != "strings" && returnArray != "string") {
            console.log("errorList >>>>", errorList);
            return errorList;
        } else if(returnArray && returnArray == "strings") {
            return errorMessages.join(", ");
        } else if(returnArray && returnArray == "string") {
            return errorMessages[0];
        } else {
            console.log("errorList string >>>>", errorList, errorList.join(", "));
            return errorList.join(", ");
        }
    }
}
